function isUniverse() {
    try {
        if (typeof window == "undefined" || !window.jQuery) {
            // serverside rendering in a cloud function
            return (
                (process &&
                    process.env &&
                    ["light.universe", "universe.server", "universe.v2.server"].includes(
                        process.env.FUNCTION_TARGET
                    )) ||
                process.env.UNIVERSE_DEBUGGER == "true"
            );
        } else {
            // clientside rendering
            return $("body").hasClass("universe") || window.location.hostname.includes("universe");
        }
    } catch (e) {
        return false;
    }
}

export { isUniverse };
export default isUniverse;
